import { jsx as _jsx } from "react/jsx-runtime";
import { useCallback } from 'react';
import { useSelector } from 'react-redux';
import styled from 'styled-components';
import resize from 'FileManagerLib/utils/resize';
import getIsFileManagerUrl from 'FileManagerLib/utils/isFileManagerUrl';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIRouterButton from 'ui-addon-react-router-dom/UIRouterButton';
import * as EmbedFrame from 'marketplace-embed/constants/EmbedFrame';
import * as EmbedGroup from 'marketplace-embed/constants/EmbedGroup';
import * as PostMessageType from 'marketplace-embed/constants/PostMessageType';
import AssetCard from 'ecosystem-marketplace-core/components/cards/AssetCard';
import AssetDemoButton from '../details/components/AssetDemoButton';
/* @ts-expect-error module is untyped */

import { useEmbedContext } from '../hooks/useEmbedContext';
import { getIsAdminPreview } from '../selectors/app';
import { getAuth // @ts-expect-error untyped dependency
} from '../selectors/auth';
import { resultCardStyles } from './utils/resultCardStyles';
import { getDetailsRoute } from '../utils/urls';
import AssetListViewCard from './AssetListViewCard';
const IMAGE_MAX_WIDTH = 480;
const StyledAssetCard = styled(AssetCard).withConfig({
  displayName: "RouterAssetCard__StyledAssetCard",
  componentId: "sc-169ks7i-0"
})(["", ""], resultCardStyles);
const StyledAssetListViewCard = styled(AssetListViewCard).withConfig({
  displayName: "RouterAssetCard__StyledAssetListViewCard",
  componentId: "sc-169ks7i-1"
})(["", ""], resultCardStyles);

const RouterAssetCard = ({
  offeringType,
  onClick,
  onTrackInteraction,
  onTrackPageview,
  result,
  view
}) => {
  const {
    isEmbedded,
    name: embedFrameName,
    sendMessage,
    sendBroadcastMessage
  } = useEmbedContext();
  const auth = useSelector(getAuth);
  const isAdminPreview = useSelector(getIsAdminPreview);
  const {
    companyName,
    exampleUrl,
    featureHeadlines,
    installsCount,
    name,
    priceCents,
    reviewSummary,
    slug,
    thumbnailUrl
  } = result;
  const getResizedThumbnailUrl = useCallback(() => {
    /* We use a third-party image service for BE Acceptance Tests. Avoid sending
     * these photos to the resizing service to prevent noisy `console.error` logs */
    if (!getIsFileManagerUrl(thumbnailUrl)) return thumbnailUrl;
    return resize(thumbnailUrl, {
      width: IMAGE_MAX_WIDTH
    }, undefined, auth);
  }, [auth, thumbnailUrl]);
  const handleOnClick = useCallback(evt => {
    if (isAdminPreview) {
      evt.preventDefault();
    } else if (isEmbedded && embedFrameName === EmbedFrame.CONTENT_CREATOR_STOREFRONT) {
      const messageArgs = [PostMessageType.NAVIGATE_TO_THEME_DETAILS, {
        slug
      }];
      sendBroadcastMessage(...messageArgs, EmbedGroup.CONTENT_CREATOR);
      sendMessage(...messageArgs);
      evt.preventDefault();
    }

    if (onClick) {
      onClick(evt);
    }
  }, [embedFrameName, isAdminPreview, isEmbedded, onClick, sendBroadcastMessage, sendMessage, slug]);

  const detailsButton = /*#__PURE__*/_jsx(UIRouterButton, {
    "data-test-id": "storefront-theme-card",
    "data-theme-slug": slug,
    onClick: handleOnClick,
    to: getDetailsRoute(offeringType, slug),
    use: "primary",
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "marketplace-assets-ui.assets.details.detailsButton"
    })
  });

  const demoButton = /*#__PURE__*/_jsx(AssetDemoButton, {
    exampleUrl: exampleUrl,
    name: name,
    onTrackInteraction: onTrackInteraction,
    onTrackPageview: onTrackPageview,
    modalPrimaryButton: detailsButton,
    providerName: companyName,
    section: "storefront-asset-card",
    slug: slug,
    use: "secondary"
  });

  if (view === 'list') {
    return /*#__PURE__*/_jsx(StyledAssetListViewCard, {
      demoButton: demoButton,
      detailsButton: detailsButton,
      featureHeadlines: featureHeadlines,
      installsCount: installsCount,
      name: name,
      offeringType: offeringType,
      priceCents: priceCents,
      providerName: companyName,
      reviewSummary: reviewSummary,
      thumbnailUrl: getResizedThumbnailUrl()
    });
  }

  return /*#__PURE__*/_jsx(StyledAssetCard, {
    demoButton: demoButton,
    detailsButton: detailsButton,
    name: name,
    offeringType: offeringType,
    priceCents: priceCents,
    providerName: companyName,
    reviewSummary: reviewSummary,
    thumbnailUrl: getResizedThumbnailUrl()
  });
};

export default RouterAssetCard;